import { render, staticRenderFns } from "./VehiclesQueryWidget.vue?vue&type=template&id=23b05fe5&scoped=true&"
import script from "./VehiclesQueryWidget.vue?vue&type=script&lang=js&"
export * from "./VehiclesQueryWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehiclesQueryWidget.vue?vue&type=style&index=0&id=23b05fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b05fe5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b05fe5')) {
      api.createRecord('23b05fe5', component.options)
    } else {
      api.reload('23b05fe5', component.options)
    }
    module.hot.accept("./VehiclesQueryWidget.vue?vue&type=template&id=23b05fe5&scoped=true&", function () {
      api.rerender('23b05fe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehiclesQueryWidget.vue"
export default component.exports